export class QuestionReportDto {
 appUserId: String;
 driveId: String;
 questionId: String;
 subCategoryId: String;
 wrongQuestionReason: String;
 wrongQuestionSuggestion?: String;
}
 